import React, { useState } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import  Index  from "views/sellermanager/Index";
import CleanNavbar from "components/Navbars/CleanNavbar";
import SellerManagerSidebar from "components/Sidebar/SellerManagerSidebar";
import imgtoData from "../../variables/imgManipulation";
import { getProfileInfo } from "../../network/ApiAxios";
import UserProfile from "views/user/userProfile";
import EditProfile from "views/examples/EditProfile";
import Events from 'views/examples/ticketing/Events'
import Cart from 'views/examples/ticketing/EventsCart'

import CheckPermission from "variables/CheckPermission";
import NewPass from "components/Reusable Components/NewPass";
import EventsMedia from "views/examples/ticketing/EventsMedia";
import { Row } from "reactstrap";
import CreateNewUser from "views/examples/CreateNewUser";
import SellerPermissions from "views/examples/ticketing/SellerPermissions";
import ReportComissionByEvent from "views/examples/ticketing/ReportComissonByEvents";
import UsersTable from "views/examples/UsersTable";
import EventSales from "views/examples/ticketing/EventSales";
import ReportTable from "views/examples/ticketing/ReportTable";
import EventsReports from 'views/examples/ticketing/EventsReports'


const User = () => {
  const history = useHistory();
  const [pic, setpic] = useState();
  const [permission, setPermission] = useState(true);
  
  const permisson = CheckPermission()
      if(!permisson){
        setPermission(false)
      }
  let user;
  user = JSON.parse(localStorage.getItem("user"));
  const role = JSON.parse(localStorage.getItem("user")).role;

  // eslint-disable-next-line
  const getProfilePic = async () => {
    const data = await getProfileInfo(user.userID);
    if (data.data.data) {
      const dat = data.data.data;
      setpic(imgtoData(dat));
    } else {
      setpic(require("../../assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  let Comp;
  let title;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
      case "/sellermanager/profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/sellermanager/index":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/sellermanager":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/sellermanager/profile/edit":
        Comp=EditProfile;
        title='Edit Profile';
        break;  
      case "/sellermanager/events":
        Comp=Events;
        title='Events';
        break; 
      case "/sellermanager/newpass":
        Comp=NewPass;
        title='Events';
        break; 
      case "/sellermanager/events/cart":
        Comp=Cart;
        title='Cart';
        break;
      case "/sellermanager/events/media":
        Comp=EventsMedia;
        title='Media';
        break;
      case "/sellermanager/new/user":
        Comp=CreateNewUser;
        title='New User';
        break;
      case "/sellermanager/permissions":
          Comp=SellerPermissions;
          title='Seller Permissions';
          break;
      case "/sellermanager/events/reportsbyevent":
          Comp=ReportComissionByEvent;
          title='Comission By Event';
          break;
      case "/sellermanager/users":
          Comp=UsersTable;
          break; 
      case "/sellermanager/events/reportsales":
          Comp=EventSales;
          break;
      case "/sellermanager/events/report/table":
          Comp=ReportTable;
          break;
      case "/sellermanager/events/reports":
          Comp=EventsReports;
          break;
  }



  return permission ? <>
              
              <SellerManagerSidebar
              pic={pic}
              logo={{
                innerLink: "/" + role + "/index",
                imgSrc: require("../../assets/img/brand/argon-react.png").default,
                imgAlt: "..."
              }}/>
              <div className="main-content">
                <CleanNavbar title={title}  />
                <Row className="mb-4"></Row>
                <Route
                component={Comp}
                />
              </div>
          </>: <Redirect to='/' />;
};

export default User;
